export const maintenance = {
    "open_a_call": "Apertura de una llamada de mantenimiento",
    "continue_to_choose": "Continúe eligiendo el método de pago para el comité de la casa",
    "name": "Nombre *",
    "email": "Correo electrónico *",
    "apt": "Número de apartamento *",
    "call_details": "Detalles de la llamada de mantenimiento",
    "category": "Categoría *",
    "urgency": "Urgencia *",
    "low": "Baja",
    "medium": "Medio",
    "high": "Alta",
    "attach_a_photo": "Adjuntar una foto",
    "desc": "Descripción *",
    "send": "Enviar",
    "fault_creation_failed": "Falló la creación de fallas",
    "fault_created": "Se ha creado una falla, resultado {{result}}",
    "thanks": "Gracias!",
    "form_submitted": "Tu formulario ha sido enviado"
}